import * as React from 'react';
import * as _ from 'lodash';
import { cleanProps } from './../../utilities/props';
export default function () {
    function scopeProps1() {
        var props = this.props;
        return React.createElement('div', _.assign({}, cleanProps(this.props)), React.createElement('div', { 'className': 'lightbox-button-block' }, props.updateItemCount > 0 ? React.createElement('div', {
            'className': 'lightbox-save-button',
            'onClick': () => this.props.onSave(this.props.level),
            'key': '218'
        }, 'Save\r\n      ', props.updateItemCount > 0 ? React.createElement('span', {
            'className': 'updateCount',
            'title': 'Unsaved item count',
            'key': '362'
        }, props.updateItemCount) : null) : null, props.updateItemCount > 0 ? React.createElement('div', {
            'className': 'lightbox-cancel-button',
            'onClick': this.props.onCancel,
            'key': '497'
        }, 'Cancel\r\n    ') : null));
    }
    return scopeProps1.apply(this, []);
}